import Mutations from '../../odata/mutations';

export default { ...new Mutations('productGroup'), ...new Mutations('productGroups') };
